import { createSlice, PayloadAction } from "@reduxjs/toolkit";


export interface Field {
  id: string;
  fieldName: string;
  fieldCode: string;
  fieldType: "Number" | "LOV" | "Text" | "Textarea";
  required: boolean;
  validation?: string;
  isCompute: boolean;
  modelId: string;
  createdAt: string;
}

export interface Model {
  id: string;
  modelCode: string;
  modelName: string;
  modelDescription: string;
  fields: Field[];
  createdAt: string;
}

interface ModelsState {
  models: Model[];
  loading: boolean;
  error: string | null;
}

const initialState: ModelsState = {
  models: [],
  loading: false,
  error: null,
};


const modelsSlice = createSlice({
  name: 'models',
  initialState,
  reducers: {
    // CRUD logic will go here
  },
});

export default modelsSlice.reducer;


// export const {
//   addModel,
//   updateModel,
//   deleteModel,
//   addField,
//   updateField,
//   deleteField,
//   setLoading,
//   setError,
// } = modelsSlice.actions;